import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/account/teams')({
    component: RouteComponent,
});

function RouteComponent() {
    return <Outlet />;
}
